import GQLClient from "../../Config/GraphqlConfig";

import { Presta, QueryConnectPrestaArgs, QueryPrestaRolesArgs, UserRoles } from "../type/type";
import { LOGIN_USER, USER_ROLES } from "./index.definitions";



export default class QueryToken {
    private client = GQLClient.getIntance()?.getClient()

    LoginUser(email: string, password: string) {
        return this.client
            .query<
                { ConnectPresta: Presta },
                QueryConnectPrestaArgs
            >(
                {
                    query: LOGIN_USER,
                    variables: {
                        email,
                        password
                    },
                    fetchPolicy: 'no-cache'
                }
            );
    }

    getPrestaRoles(email: string) {
        return this.client
            .query<
                { UserRoles: UserRoles },
                QueryPrestaRolesArgs
            >(
                {
                    query: USER_ROLES,
                    variables: {
                        email
                    },
                    fetchPolicy: 'no-cache'
                }
            );
    }

 
}